import { useGoTo } from 'hooks/useGoTo';
import { pluginSettingsVar } from '../../../apollo/store';
import { useCallback, useEffect } from 'react';
import { useCheckAutoConfig } from './useCheckAutoConfig';

export const useCheckAutoConfigAndRedirect = () => {
    const goTo = useGoTo();
    const { autoConfig, linkToProductOverview } = pluginSettingsVar();
    const { checkAutoConfig, exitPath, error, loading } = useCheckAutoConfig(autoConfig || {});

    const detectExitPath = useCallback(() => {
        if (!autoConfig) {
            goTo(linkToProductOverview);
        } else {
            checkAutoConfig();
        }
    }, [autoConfig, linkToProductOverview, goTo, checkAutoConfig]);

    useEffect(() => {
        if (exitPath) {
            goTo(exitPath);
        }
    }, [exitPath, goTo]);

    useEffect(() => {
        detectExitPath();
    }, [detectExitPath]);

    return {
        detectExitPath,
        exitPath,
        error,
        loading,
    };
};
